import React from 'react'
import PropTypes from 'prop-types'
import { toTitleCase } from 'utils/stringHelpers'
import CoursePreview from './component'
import {
  FlaggedRouteContentGetter as RouteContentGetter,
  RouteContentType,
} from 'layers/content/v2/Hocs/FlaggedRouteContentGetter'
import withApiError from 'layers/errorHandling/apiError'
import { UnitType } from 'components/UnitComponent/types'
import { resolveRouteServiceApp } from 'utils/productHelpers'

export const getGradeDisplayTitleFromSlug = slug =>
  slug === 'grade-k' ? 'Grade K' : toTitleCase(slug.replace(/-/g, ' ')).trim()

// TODO: This is problematic from an i18n perspective
export const getPageTitleFromSlug = slug =>
  slug === 'grade-k'
    ? 'Kindergarten Lessons'
    : toTitleCase(slug.replace(/-/g, ' ') + ' Lessons').trim()

export const countLessonsInUnits = units =>
  units?.reduce((acc, unit) => acc + unit?.lessons?.length, 0) ?? 0

export const unitIsOutOfRange = (unitIndex, units) =>
  unitIndex < 0 || unitIndex >= units.length

export const Container = props => {
  const {
    routeContent,
    match,
    onSelectUnit,
    productName,
    unitId,
    getData,
  } = props
  const { content, loading } = routeContent
  const courseSlug = match?.params?.course ?? ''
  const displayTitle = getGradeDisplayTitleFromSlug(courseSlug)

  const { unit } = content
  const { acknowledgements, scopeAndSequenceData, lessonsAmounts } = getData(
    unit,
  )
  return (
    !loading && (
      <CoursePreview
        acknowledgements={acknowledgements}
        displayTitle={displayTitle}
        lessonsAmounts={lessonsAmounts}
        match={match}
        onSelectUnit={onSelectUnit}
        productName={productName}
        scopeAndSequenceData={scopeAndSequenceData}
        unit={unit}
        unitId={unitId}
      />
    )
  )
}

Container.propTypes = {
  getData: PropTypes.func.isRequired,
  match: PropTypes.object,
  onSelectUnit: PropTypes.func.isRequired,
  productName: PropTypes.string,
  routeContent: RouteContentType(UnitType).isRequired,
  unitId: PropTypes.string.isRequired,
}
const CoursePreviewContainer = RouteContentGetter(withApiError(Container), {
  app: ({ route }) => resolveRouteServiceApp(route),
})

CoursePreviewContainer.displayName = 'CoursePreviewContainer'

export default CoursePreviewContainer
